export const texts = {
  student: 'first-contact.first-contact-tools.texts.student',
  tutor: 'first-contact.first-contact-tools.texts.tutor',
  methodist: 'first-contact.first-contact-tools.texts.methodist',
  school: 'first-contact.first-contact-tools.texts.school',
};
